import type { BasePrivateConfig } from '@centric-os/types';

/**
 * When the config service has USE_KEYSTORE_RESTRICTED enabled, withheld
 * keystore secrets are removed from their top-level slot (e.g. `keystore.payment`)
 * and collected under `keystore.restricted` keyed by the original name
 * (e.g. `keystore.restricted.payment`).
 *
 * This function hoists every restricted entry back into its top-level keystore
 * slot and removes the `restricted` wrapper so all downstream consumers see
 * the same shape regardless of the feature flag.
 */
export function normalizeKeystoreRestricted<T extends BasePrivateConfig>(config: T): T {
  if (!config?.keystore?.restricted) {
    return config;
  }

  const { restricted, ...remainingKeystore } = config.keystore;

  return {
    ...config,
    keystore: {
      ...restricted,
      ...remainingKeystore,
    },
  };
}
